import type { IdentityProfile } from '@Types/IdentityProfile.interface';

/**
 * Normalize a ZIP for the masked ("#####") KYC zip field: strip non-digits and
 * keep the first 5.
 *
 * ID-sourced ZIPs are frequently 9-digit / ZIP+4 (e.g. "78750-1234"). Writing the
 * raw value straight into the form model bypasses the input mask, so the field
 * displays a clamped "78750" while the model keeps the full value and fails the
 * 5-digit zip-code validation. Normalizing keeps the model and the displayed
 * value in sync (PLAT-2631).
 */
export const normalizeZipCode = (zip: string): string => zip.replace(/\D/g, '').slice(0, 5);

export const useIdentityProfileForm = () => {

    const createEmptyIdentityProfile = (): IdentityProfile => {
        return {
            firstName: '',
            lastName: '',
            email: '',
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            zip: '',
            dateOfBirth: '',
            ssn: ''
        };
    }

    return {
        createEmptyIdentityProfile
    };
}

export default useIdentityProfileForm;